<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Profile|Silent Hours') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Profile|Silent hours allow you to define time periods when you do not want to receive task notifications. This helps you maintain focus during specific hours or days.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|How It Works') }}</h4>
            <p>
              {{
                s__(
                  'Profile|During silent hours, notifications for new tasks, comments, and updates will be suppressed.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Silent Hours Digest') }}</h4>
            <p>
              {{
                s__(
                  'Profile|When silent hours end, a scheduled job runs every minute to check if your silent hours period has just finished. If so, you will receive a digest message shortly after silent hours end, containing all notifications that were suppressed during the silent period.'
                )
              }}
            </p>
            <p>
              {{
                s__(
                  'Profile|If no notifications occurred during silent hours, no digest will be sent.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Use Cases') }}</h4>
            <p>
              {{
                s__(
                  "Profile|Silent hours are useful for maintaining work-life balance, focusing during deep work sessions, or avoiding interruptions during meetings or personal time. The digest ensures you don't miss important updates while respecting your quiet time."
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Profile|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
